import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import { WORKER_KEYS } from './useWorkerProfile';
import type { Job } from '@/types/worker';

export const useJob = (jobId: string) => {
    return useQuery({
        queryKey: WORKER_KEYS.job(jobId),
        enabled: !!jobId,
        queryFn: async (): Promise<Job> => {
            const { data } = await api.get(API_ROUTES.workerJobDetail(jobId));
            return data;
        },
        staleTime: 30 * 1000,
    });
};
